var baseValidationFn = (value, _ref) => {
  var {
    isChecked,
    props
  } = _ref;
  var isRequired = [true, 'true'].includes(props.required);
  var valueMissing = isRequired && !isChecked;
  var errors = valueMissing ? ['valueMissing'] : [];
  return {
    errors,
    isValid: !valueMissing,
    valueMissing
  };
};

export { baseValidationFn };